/** Flattens the keys of the provided object
 *
 * EG: `{"a": {"b": 1}}`
 *
 * Returns: `{"a.b": 1}` *
 */
export function flattenObject(ob: any): { [key: string]: any } {
  var toReturn: any = {};

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == "object" && ob[i] !== null) {
      var flatObject = flattenObject(ob[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + "." + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}

export function delay(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
